import axios from 'axios';
import { validateCreatorFile } from './mediaValidation';

export async function uploadCreatorFile(file, onUploadProgress) {
  const formData = new FormData();
  formData.append('file', file);

  const res = await axios.post('/api/creator/upload', formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
    onUploadProgress,
  });

  if (!res.data.success) {
    throw new Error(res.data.message || '未知错误');
  }

  return {
    url: res.data.data.url,
    metadata: res.data.data.metadata || null,
  };
}

export function formatReferenceUploadFailures(failures) {
  if (!failures.length) return '';
  return failures.map((item) => `${item.name}: ${item.reason}`).join('；');
}

export async function processReferenceFiles(
  files,
  {
    existingItems = [],
    model,
    validateFile = validateCreatorFile,
    uploadFile = uploadCreatorFile,
    onUploadProgress,
    onBatchProgress,
  } = {}
) {
  const accepted = [];
  const failures = [];
  const stagedItems = [...existingItems];
  const fileList = Array.from(files || []);
  const progressByIndex = new Array(fileList.length).fill(0);

  for (const [index, file] of fileList.entries()) {
    let metadata;

    try {
      metadata = await validateFile(file, {
        scope: 'reference',
        existingItems: [...stagedItems],
        model,
      });
    } catch (error) {
      failures.push({ name: file.name, reason: error.message });
      continue;
    }

    try {
      const uploaded = await uploadFile(file, (evt) => {
        onUploadProgress?.(evt);
        if (evt?.total) {
          progressByIndex[index] = Math.round((evt.loaded / evt.total) * 100);
          const totalProgress = Math.round(
            progressByIndex.reduce((sum, value) => sum + value, 0) / fileList.length
          );
          onBatchProgress?.(totalProgress);
        }
      });
      accepted.push({
        file,
        url: uploaded.url,
        metadata: metadata || uploaded.metadata || null,
      });
      stagedItems.push({
        id: `temp-${accepted.length}-${file.name}`,
        url: uploaded.url,
        name: file.name,
        ...(metadata || {}),
      });
    } catch (error) {
      failures.push({ name: file.name, reason: error.message });
    }
  }

  return { accepted, failures };
}
